import {FETCH_LOTTERY_USER, LIST_LOTTERY_USER} from "./types";

const init = {
    isLoading: false,
    list: {},
    options:[]

};

export default (state = init, {type, payload,options}) => {
    switch (type) {
        case FETCH_LOTTERY_USER:
            return {
                ...state,
                isLoading: true
            };
        case LIST_LOTTERY_USER:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                options: options
            };
        default:
            return state;
    }
}